import { Modal } from '@heroui/react'
import { useTranslation } from 'react-i18next'

import VehicleForm from './VehicleForm.tsx'

interface VehicleDialogProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  vehicleId?: string;
}

export function VehicleDialog({ isOpen, onOpenChange, vehicleId }: VehicleDialogProps) {
  const { t } = useTranslation()

  const closeModal = () => onOpenChange(false)

  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
      <Modal.Backdrop variant="blur" className="bg-zinc-950/40" isDismissable>
        <Modal.Container placement="center">
          <Modal.Dialog>
            <Modal.CloseTrigger />
            <Modal.Header>
              <Modal.Heading className="font-bold ">
                {vehicleId ? t('vehicles.edit_vehicle') : t('vehicles.new_vehicle')}
              </Modal.Heading>
            </Modal.Header>
            <Modal.Body className={'mt-4'}>
              <VehicleForm
                key={vehicleId || 'new'}
                vehicleId={vehicleId}
                onSuccess={closeModal}
                onCancel={closeModal}
              />
            </Modal.Body>
          </Modal.Dialog>
        </Modal.Container>
      </Modal.Backdrop>
    </Modal>
  )
}
